import { createSelector } from 'reselect';
import { FINAL_PAGE_VERSION_SPEC, SHORT_FLOW_SPEC } from '../../petriSpecs';
import { IRootState, Selector } from '../rootReducer';
import type { IExperiments } from './types';

const getExperiments = (state: IRootState): IExperiments => state.experiments;

const getFinalPageVersion: Selector<string> = createSelector(
  getExperiments,
  (experiments) => experiments[FINAL_PAGE_VERSION_SPEC],
);

const isShortFlowEnabled: Selector<boolean> = createSelector(
  getExperiments,
  (experiments) => experiments[SHORT_FLOW_SPEC] === 'true',
);

export { getExperiments, getFinalPageVersion, isShortFlowEnabled };
